<template>
  <div
    v-if="loaded"
    class="page"
  >
    <div class="page__sidebar">
      <waste-side-bar
        :counters="sidebarSummary"
        @update-option="onClickUpdateFilter($event)"
        @click-add-filter="onClickAddFilter"
      />
    </div>
    <div class="page__main">
      <router-view
        ref="mainContent"
        class="page__main-content"
        @reload-sidebar-summary="loadSidebarSummary"
      />
    </div>
  </div>
</template>

<script>
import WasteSideBar from './sideBar/WasteSideBar'
import sideBarStore from './sideBar/wasteSideBarStore'
import wasteSampleService from '@/modules/wasteModule/services/WasteSampleService'
import { sampleState } from '@/api/resources/entityState/sample-state'

export default {
    name: 'WasteIndex',
    components: {
        WasteSideBar
    },
    data() {
        return {
            loaded: false,
            sideBarState: sideBarStore.state,
            sidebarSummaryInterval: null,
            sidebarSummary: null,
            predefinedFiltersSummary: null
        }
    },
    computed: {
        routeName() {
            return this.$route.name
        },
        labId() {
            return this.$store.getters.labId
        }
    },
    async created() {
        try {
            if (this.sideBarState.config.defaultOptionId) {
                sideBarStore.selectDefaultOption()
            }

            await Promise.all([
                sampleState.loadStates(),
                this.loadSidebarSummary()
            ])

            this.sidebarSummaryInterval = this.$_setSummaryInterval(this.loadSidebarSummary)
        } finally {
            this.loaded = true
        }
    },
    beforeDestroy() {
        if (this.sidebarSummaryInterval !== null) {
            clearInterval(this.sidebarSummaryInterval)
        }
        this.cleanSearchStateGlobalMixin()
    },
    methods: {
        async loadSidebarSummary() {
            this.sidebarSummary = await wasteSampleService.samplesSummary(this.labId)
        },
        onClickUpdateFilter(option) {
            if (this.$refs.mainContent.onSideBarClickUpdateFilter) {
                this.$refs.mainContent.onSideBarClickUpdateFilter(option)
            }
        },
        onClickAddFilter() {
            if (this.$refs.mainContent.onSideBarClickAddFilter) {
                this.$refs.mainContent.onSideBarClickAddFilter()
            }
        }
    }
}

</script>
